/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import I18n from 'components/Translate/I18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { featuresActions, featuresConstans } from '../../modules/features/actions';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import FeaturesRow from 'views/Features/FeaturesRow';
import SuccessInfo from 'components/Info/SuccessInfo';
import AlertInfo from 'components/Info/AlertInfo';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { ServicesMvneType } from '../../modules/lib/hooks/useOperatorType';
import { ActiveFeatureItemSdgBme } from './component/opl/Active/ActiveFeatureItemSdgBme';
import { ComponentParamsDialog } from './component/ComponentParamsDialog';
import { notificationConstants } from '../../modules/notifications/notifications';

class FeaturesActiveList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            simCard: this.props.simCard,
            activeList: null,
            deleteParams: null,
            alert: null,
            definitionComponent: null,
            componentParamsDialogOpen: false,
            verbType: null,
            componentParamsDialogTitle: null,
            alreadySelectedValues: null
        };
        this.loader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount() {
        this.initial();
    }

    initial = () => {
        this.loader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_services')),
            'none',
            [
                { name: 'simCardId', value: this.state.simCard.id },
                { name: 'pagination', value: 'false' },
            ],
            [{ name: 'createdAt', value: 'desc' }],
            (data) => {
                this.setState({
                    activeList: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    deleteFeatureConfirm = (params) => {
        this.setState({
            deleteParams: params,
            alert: (
                <AlertInfo
                    onConfirm={this.deleteCallApi}
                    onCancel={this.cancelDelete}
                    confirmBtnText={'simcard:f.remove_component'}
                    cancelBtnText={'general:common.cancel'}
                    content="simcard:f.confirm_remove_component"
                />
            ),
        });
    };

    cancelDelete = () => {
        this.setState({ alert: null, deleteParams: null });
    };

    deleteCallApi = () => {
        const params = this.state.deleteParams;
        if (params !== null) {
            const { dispatch } = this.props;
            dispatch(
                featuresActions.post(
                    FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
                    params,
                    featuresConstans.FEATURES_POST,
                    () => {
                        this.setState(
                            {
                                activeList: {},
                                alert: (
                                    <SuccessInfo
                                        onConfirm={this.cancelDelete}
                                        confirmBtnText="general:common.ok"
                                        content="simcard:f.remove_component_request_send"
                                    />
                                ),
                            },
                            this.initial
                        );
                    }
                )
            );
        } else {
            this.cancelDelete();
        }
    };

    confirmCallback = (componentParams) => {
        const { dispatch } = this.props;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
            'post_active_component_with_params',
            componentParams,
            (data) => {
                this.setState({ activeList: null }, () => {
                    dispatch({
                        type: notificationConstants.SUCCESS,
                        message: 'simcard:f.activate_component_request_send',
                    });
                    this.closeComponentParamsDialog();
                    this.initial();
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    openComponentParamsDialog = (verbType, definitionComponent, componentParamsDialogTitle, alreadySelectedValues) => {
        this.setState({
            definitionComponent: definitionComponent,
            componentParamsDialogOpen: true,
            verbType: verbType,
            componentParamsDialogTitle: componentParamsDialogTitle,
            alreadySelectedValues: alreadySelectedValues
        });
    };

    closeComponentParamsDialog = () => {
        this.setState({
            definitionComponent: null,
            componentParamsDialogOpen: false,
            verbType: null,
            componentParamsDialogTitle: null,
        });
    };

    render() {
        const { activeList, alert, componentParamsDialogOpen, definitionComponent, verbType, simCard, componentParamsDialogTitle,alreadySelectedValues } = this.state;
        return (
            <React.Fragment>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                <I18n trans="simcard:f.id" />
                            </TableCell>
                            <TableCell align="left">
                                <I18n trans="simcard:f.component_name" />
                            </TableCell>
                            <TableCell align="left">
                                <I18n trans="simcard:f.activated_at" />
                            </TableCell>
                            <TableCell align="right">
                                <I18n trans="simcard:f.action" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {activeList &&
                            activeList['hydra:member'] &&
                            activeList['hydra:member'].map((row) => {
                                return (
                                    <ActiveFeatureItemSdgBme
                                        key={'services_' + row.id}
                                        simCardService={row}
                                        deleteFeature={this.deleteFeatureConfirm}
                                        openComponentParamsDialog={this.openComponentParamsDialog}
                                    />
                                );
                            })}
                    </TableBody>
                </Table>
                {alert}
                {definitionComponent && verbType && (
                    <ComponentParamsDialog
                        open={componentParamsDialogOpen}
                        definitionComponent={definitionComponent}
                        isActivationMode={false}
                        closeCallback={this.closeComponentParamsDialog}
                        confirmCallback={this.confirmCallback}
                        simCardId={simCard.id}
                        simCard={simCard}
                        verbType={verbType}
                        title={componentParamsDialogTitle}
                        alreadySelectedValues={alreadySelectedValues}
                    />
                )}
            </React.Fragment>
        );
    }
}

FeaturesActiveList.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return { ...state };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(FeaturesActiveList);
export default Enhance;
